import axios from 'axios'

const API_BASE_URL = 'http://localhost:13000/api/v1'

export interface Unit {
  id: string
  tenant_id: string
  unit_type: string
  unit_id: string
  serial_number?: string
  status: string
  location: string
  description?: string
  specifications?: Record<string, any>
  created_at: string
  updated_at: string
}

export interface CreateUnitRequest {
  unit_type: string
  unit_id: string
  serial_number?: string
  status: string
  location: string
  description?: string
  specifications?: Record<string, any>
}

export interface UnitListResponse {
  items: Unit[]
  total: number
  skip: number
  limit: number
}

class UnitsService {
  async listUnits(
    skip: number = 0,
    limit: number = 50,
    filters?: {
      status?: string
      location?: string
      unit_type?: string
    }
  ): Promise<UnitListResponse> {
    try {
      const params = new URLSearchParams()
      params.append('skip', String(skip))
      params.append('limit', String(limit))

      if (filters?.status) {
        params.append('status', filters.status)
      }
      if (filters?.location) {
        params.append('location', filters.location)
      }
      if (filters?.unit_type) {
        params.append('unit_type', filters.unit_type)
      }

      const response = await axios.get(`${API_BASE_URL}/equipment/units?${params.toString()}`)
      return response.data
    } catch (error) {
      console.error('Error listing units:', error)
      throw error
    }
  }

  async getUnit(id: string): Promise<Unit> {
    try {
      const response = await axios.get(`${API_BASE_URL}/equipment/units/${id}`)
      return response.data
    } catch (error) {
      console.error(`Error fetching unit ${id}:`, error)
      throw error
    }
  }

  async createUnit(data: CreateUnitRequest): Promise<Unit> {
    try {
      const response = await axios.post(`${API_BASE_URL}/equipment/units`, data)
      return response.data
    } catch (error) {
      console.error('Error creating unit:', error)
      throw error
    }
  }

  async updateUnit(id: string, data: Partial<CreateUnitRequest>): Promise<Unit> {
    try {
      const response = await axios.put(`${API_BASE_URL}/equipment/units/${id}`, data)
      return response.data
    } catch (error) {
      console.error(`Error updating unit ${id}:`, error)
      throw error
    }
  }

  async deleteUnit(id: string): Promise<void> {
    try {
      await axios.delete(`${API_BASE_URL}/equipment/units/${id}`)
    } catch (error) {
      console.error(`Error deleting unit ${id}:`, error)
      throw error
    }
  }
}

export const unitsService = new UnitsService()
